export class ApplicationInsightsNotInitializedError extends Error {
  constructor() {
    super('Application Insights not yet initialized');
    this.name = 'ApplicationInsightsNotInitializedError';
  }
}
//# sourceMappingURL=ApplicationInsightsNotInitializedError.js.map